import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MyApp } from 'src/app/api/helper/app';
import { NavController, ModalController, ToastController, PopoverController } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { StammdatenService } from 'src/app/api/stammdaten.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UntypedFormBuilder } from '@angular/forms';
import { TourService } from 'src/app/api/tour.service';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { TranslateService } from '@ngx-translate/core';
import { WaageService } from 'src/app/api/waage.service';
import { WebView } from '@awesome-cordova-plugins/ionic-webview/ngx';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';

import { NachrichtService } from 'src/app/api/nachricht.service';

const log = new Logger('LeegewichtWiegenPage');

@Component({
    selector: 'app-leergewicht-wiegen',
    templateUrl: './leergewicht-wiegen.page.html',
    styleUrls: ['./leergewicht-wiegen.page.scss'],
    standalone: false
})
export class LeegewichtWiegenPage implements OnInit {
    app = MyApp.current;

    constructor(
        public formBuilder: UntypedFormBuilder,
        private webView: WebView,
        private popoverController: PopoverController,
        private nachrichtenService: NachrichtService,
        private stammdatenService: StammdatenService,
        private auftragService: AuftragService,
        public domSanitizationService: DomSanitizer,
        private modalController: ModalController,
        private tourService: TourService,
        private cdr: ChangeDetectorRef,
        private toastController: ToastController,
        private nav: NavController,
        private waageService: WaageService) {


    }

    async ngOnInit() {
        this.updateUi();
    }

    async ionViewWillEnter() {
        log?.debug('ionViewWillEnter');
    }


    ionViewDidEnter() {
    }

    ionViewWillLeave() {
    }

    updateUi() {

    }
}
